import "./App.css";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import reactParse from "html-react-parser";
import cipherModule from "./modules/cipher.js";
import regexEscape from "escape-string-regexp";
import { Analytics } from "@vercel/analytics/react";


const namesToComponents = {
    "link": Link,
    "callreplace": CallFormat
}

function testComponentSyntax(string) {
    return string.startsWith("comp_") && namesToComponents[string.slice(5)]
}
const callNameToFunction = {
    "localResource": cipherModule.callFetchResource,
}

function NavBar({URL, setPanelOpen}) {
    
    return (
        <div className="navBar">
            <div className="navTitle">Qlexer</div>
            <div className="navPath"><div className="navPathInner">{URL.pathname}</div></div>
            <div><Link to="/" className="navButton">Home</Link></div>
            <div><Link to="/blog/" className="navButton">Blog</Link></div>
            <div><button className="buttonLink navButton" onClick={() => {setPanelOpen("keyring")}}>Manage Keyring</button></div>
        </div>
    );
}

function domnodeToJsx(domnode, globalState) {
    if (domnode.data) {
        return domnode.data;
    } else {
        let domnodeChildren = []
        for (let child of domnode.children) {
            domnodeChildren.push(domnodeToJsx(child));
        }
        if (testComponentSyntax(domnode.name)) {
            let ReactElementName = namesToComponents[domnode.name.slice(5)];
            let reactElement = (
                <ReactElementName {...domnode.attribs} _globalState={globalState}>{domnodeChildren}</ReactElementName>
            );
            return reactElement;
        } else {
            let ElementName = domnode.name;
            let element = (
                <ElementName {...domnode.attribs}>{domnodeChildren}</ElementName>
            );
            return element;
        }
    }
}

function parseParams(paramsString) {
    let parsedParams = {};
    let key = "";
    let value = "";
    let parsingKey = true;
    let parsingBackslash = false;
    let parsingNewEntry = false;

    for (let character of paramsString) {
        if (character === "=" && parsingKey) {
            parsingKey = false;
        } else if (parsingBackslash) {
            if (character === ";") {
                value += ";";
            } else if (character === "\\") {
                console.log(value)
                value += "\\";
            }
            parsingBackslash = false;
        } else if (character === "\\" && !parsingKey) {
            parsingBackslash = true;
        } else if (character === ";") {
            parsedParams[key] = value;
            key = "";
            value = "";
            parsingKey = true;
            parsingNewEntry = true;
        } else if (!(character === " " && parsingNewEntry))  {
            parsingNewEntry = false;
            if (parsingKey) {
                key += character;
            } else {
                value += character;
            }
        }
    }
    return parsedParams;
}

function CallFormat({ children, placeholder, call, params = "", _globalState }) {
    let paramsObject = parseParams(params);
    let callReturn = callNameToFunction[call](paramsObject, _globalState);

    function substitute(string) {
        return string.replace("\n", "").replace(regexEscape(placeholder), callReturn);

    }
    
    function replaceValues(node) {
        let childrenDOM = [];
        let attributesDOM = [];
        for (let property in node.props) {
            if (property === "children") {
                childrenDOM = [];
                let children;
                if (Array.isArray(node.props.children)) {
                    children = node.props.children;
                } else {
                    children = [node.props.children];
                }
                for (let child of children) {
                    if (typeof child === "string") {
                        let replacedString = substitute(child);
                        if (replacedString !== "") {
                            childrenDOM.append(replacedString);
                        }
                    } else {
                        childrenDOM.append(replaceValues(child));
                    }
                }
            } else {
                attributesDOM[property] = substitute(node.props[property]);
            }
        }
        let Element; 
        if (testComponentSyntax(node.type)) {
            Element = namesToComponents[node.type.slice(5)];
        } else {
            Element = node.type;
        }
        if (childrenDOM.length !== 0) {
            return <Element {...attributesDOM}>{childrenDOM}</Element>;
        } else {
            return <Element {...attributesDOM} />;
        }
    }
    if (Array.isArray(children)) {
        let replacedChildren = [];
        for (let child of children) {
            if (typeof child === "string") {
                let replacedString = substitute(child)
                if (replacedString !== "") {
                    replacedChildren.push(replacedString)
                } 
            } else {
                replacedChildren.push(replaceValues(child))
            }
        }
        return replacedChildren;
    } else {
        console.log(replaceValues(children))
        return replaceValues(children);
    }
}

function ContentBody({ content, globalState }) {
    return reactParse(content, {
        replace: element => {
            if (element.name) { 
                if (element.name.startsWith("comp_") && namesToComponents[element.name.slice(5)]) {
                    return domnodeToJsx(element, globalState);
                }
            }
        }
    })
}


function AuthDecryptPrompt({ page, setHasKeyState, globalState, invalidKeyring }) {
    let [inputValueKey, setInputValueKey] = React.useState("");
    let [inputValueSave, setInputValueSave] = React.useState(true);
    let [message, setMessage] = React.useState(invalidKeyring ? "Key in keyring invalid." : "");
    function handleSubmit(event) {
        event.preventDefault();
        if (cipherModule.verifyKey(page, inputValueKey)) {
            globalState.key = inputValueKey;
            if (inputValueSave) {
                globalState.keyring[page.access] = inputValueKey;
                localStorage.setItem("keyring", JSON.stringify(globalState.keyring))
            }
            setHasKeyState(true);
        } else {
            setMessage("Key invalid.");
            setInputValueKey("");
        }
    } 
    return (
        <div className="prompt">
            <form onSubmit={handleSubmit}>
                <p className="promptText">Key required: <b>{page.access}</b></p>
                <textarea className="promptTextarea" onChange={(event) => {
                    setInputValueKey(event.target.value);
                    setMessage("");
                }} value={inputValueKey} />
                {message === "" || <span className="promptMessage"><br />{message}</span>}
                <br />Save to keyring: <input type="checkbox" onChange={(event) => {
                    setInputValueSave(event.target.checked);
                }} checked={inputValueSave} />
                <p className="prmptText"><input type="submit" /></p>
            </form>
        </div>
    )
}

function AuthDecryptPage({ page, globalState }) {
    let pageContent = cipherModule.decryptPage(page, globalState.key)
    return <ContentBody content={pageContent} globalState={globalState} />
}

function AuthDecrypt({ page, globalState }) {
    let hasAccess = false;
    let invalidKeyring = false;
    if (globalState.keyring[page.access]) {
        if (cipherModule.verifyKey(page, globalState.keyring[page.access])) {
            hasAccess = true;
            globalState.key = globalState.keyring[page.access];
        } else {
            invalidKeyring = true;
        }
    }
    let [hasKeyState, setHasKeyState] = React.useState(hasAccess);
    if (hasKeyState) { 
        return (
            <AuthDecryptPage page={page} globalState={globalState} />
        ) 
    } else { 
        return (
            <AuthDecryptPrompt page={page} setHasKeyState={setHasKeyState} globalState={globalState} invalidKeyring={invalidKeyring} />
        )
    }
}

function Content({ URL, globalState }) {
    
    let pageJSON;
    try {
        pageJSON = require("./pages" + URL.pathname);
    } catch(e) {
        pageJSON = {
            validPage: false,
            code: "404"
        };
    }
    if (!pageJSON.validPage) {
        return (
            <p>Error {pageJSON.code || 500} </p>
        );
    }
    if (pageJSON.access === "public") {
        globalState.key = null;
        return (
            <ContentBody content={pageJSON.content} globalState={globalState}/>
        );
    } else {
        return (
            <AuthDecrypt page={pageJSON} globalState={globalState}/>
        )
    }
}

function KeyringPanel({ setPanelOpen, globalState }) {
    let [inputValueKeyring, setInputValueKeyring] = React.useState(""); 
    let [message, setMessage] = React.useState(""); 
    let [keysDOMState, setKeysDOMState] = React.useState(getKeysDOM());
    function getKeysDOM() {
        let keysDOM = [];
        for (let key in globalState.keyring) {
            keysDOM.push(<li>{key}</li>);
        }
        return keysDOM;
    }
    function handleSubmit(event) {
        event.preventDefault();
        let inputKeyringObject;
        try {
            inputKeyringObject = JSON.parse(inputValueKeyring);
        } catch(error) {
            setMessage("Invalid JSON object.");
            return;
        }
        for (let key in inputKeyringObject) {
            if (typeof inputKeyringObject[key] !== "string") {
                setMessage("Invalid keyring.");
                return;
            }
        }
        localStorage.setItem("keyring", JSON.stringify(inputKeyringObject));
        globalState.keyring = inputKeyringObject;
        setKeysDOMState(getKeysDOM());
        setMessage("Loaded keyring.")
    }
    return (
        <div className="prompt">
            <button className="promptClose buttonLink" onClick={() => {
                setPanelOpen(null);
            }}>Close</button>
            <form onSubmit={handleSubmit}>
                <p className="promptText">Load keyring: </p>
                <textarea className="promptTextarea" onChange={(event) => {
                    setInputValueKeyring(event.target.value);
                    setMessage("");
                }} value={inputValueKeyring} />
                {message === "" || <span className="promptMessage"><br />{message}</span>}
                <br /><input type="submit" />
                <p className="promptText">Keys on keyring:</p>
                <div className="keyringPanelScroll">
                    <ul>
                        {keysDOMState}
                    </ul>
                </div>
            </form>
        </div>
    )
}

const panelList = {
    "keyring": KeyringPanel
}
function Panel({ panelOpen, setPanelOpen, globalState }) {
    let OpenPanel = panelList[panelOpen];
    return <OpenPanel setPanelOpen={setPanelOpen} globalState={globalState} />;
}

export default function App() {
    const URLState = new URL(window.location.href);
    let [panelOpen, setPanelOpen] = React.useState(null);
    let location = useLocation();
    React.useEffect(() => {
        setPanelOpen(null);
    }, [location]);
    let globalState = {};
    if (!(globalState.keyring)) {
        let keyringUnparsed = localStorage.getItem("keyring");
        if (keyringUnparsed !== null) {
            globalState.keyring = JSON.parse(keyringUnparsed);
        } else {
            globalState.keyring = {};
        }
    }
    return (
        <div className="app">
            <NavBar URL={URLState} setPanelOpen={setPanelOpen}/>
            {panelOpen === null ? 
                <Content URL={URLState} globalState={globalState}/> :
                <Panel panelOpen={panelOpen} setPanelOpen={setPanelOpen} globalState={globalState}/>
            }
            <Analytics />
        </div>
    )
}
